module.exports = __webpack_public_path__ + "img/file-icon-2.e57a7af8.svg";